import React, { useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import { Affix, Space } from "antd";
import DrawerBar from "./drawer";

const NavbarMobile: React.FC = () => {
  const labels = useMemo(
    () => [
      { id: 1, title: "Home", path: "/" },
      { id: 2, title: "Travel", path: "/travel" },
      { id: 3, title: "Guides", path: "/guides" },
      { id: 4, title: "Food", path: "/food" },
      { id: 5, title: "Hotels", path: "/hotels" },
    ],
    []
  );

  const [isMainMenuClick, setIsMainMenuClick] = useState(false);
  const location = useLocation();

  return (
    <Affix offsetTop={0}>
      <div className="w-full flex justify-center bg-white">
        <div className="w-full max-w-[1116px] h-[55px] px-8 z-50 flex items-center justify-between">
          <div
            className="flex items-center relative z-10 cursor-pointer"
            onClick={() => setIsMainMenuClick(!isMainMenuClick)}
          >
            <img
              src="icon/list2.png"
              alt="list2Icon"
              className="w-7 h-7 mr-0.5"
            />
            <span className="text-[#5c687a] text-base font-medium">
              Main Menu
            </span>

            {isMainMenuClick ? (
              <ul className="absolute top-7 left-0 z-10 flex flex-col bg-white px-8 py-5 text-base font-semibold text-gray-500 cursor-pointer">
                {labels.map((label, id) => (
                  <Link key={id} to={label.path}>
                    <li
                      key={id}
                      className={`flex items-center py-3 ${
                        location.pathname === label.path
                          ? "text-[#5b68d3]"
                          : "hover:text-[#5b68d3]"
                      }`}
                    >
                      {label.title === "Home" ? (
                        <Link to={label.path}>
                          <Space>
                            <span className="relative flex justify-center items-center h-2 w-2">
                              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#5b68d3] opacity-75"></span>
                              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#5b68d3]"></span>
                            </span>
                            {label.title}
                          </Space>
                        </Link>
                      ) : (
                        <span>{label.title}</span>
                      )}
                    </li>
                  </Link>
                ))}
              </ul>
            ) : (
              ""
            )}
          </div>

          <div className="flex flex-shrink-0 items-center space-x-2 ml-2">
            <DrawerBar />
          </div>
        </div>
      </div>
    </Affix>
  );
};

export default NavbarMobile;
